import { render, staticRenderFns } from "./MortgageRequestFrame.vue?vue&type=template&id=76951fe1&scoped=true&"
import script from "./MortgageRequestFrame.vue?vue&type=script&lang=js&"
export * from "./MortgageRequestFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76951fe1",
  null
  
)

export default component.exports